import _sfc_main from "./Tooltip.vue2.js";
/* empty css             */
import _export_sfc from "../../_virtual/_plugin-vue_export-helper.js";
const Tooltip = /* @__PURE__ */ _export_sfc(_sfc_main, [["__scopeId", "data-v-0419c808"]]);
export {
  Tooltip as default
};
//# sourceMappingURL=Tooltip.vue.js.map
